import { render, staticRenderFns } from "./AceptoCorreoVerde.vue?vue&type=template&id=26ecbe36&scoped=true&"
import script from "./AceptoCorreoVerde.vue?vue&type=script&lang=js&"
export * from "./AceptoCorreoVerde.vue?vue&type=script&lang=js&"
import style0 from "./AceptoCorreoVerde.vue?vue&type=style&index=0&id=26ecbe36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ecbe36",
  null
  
)

export default component.exports